import { Component } from "@angular/core";

@Component({
  selector: "app-icon-ns-logo-footer",
  standalone: true,
  imports: [],
  templateUrl: "./ns-logo-footer.component.html",
})
export class NsLogoFooterIconComponent {}
